'use strict';

exports.__esModule = true;
exports.PaginationButton = exports.Pagination = undefined;

var _Pagination2 = require('./Pagination');

var _Pagination3 = _interopRequireDefault(_Pagination2);

var _PaginationButton2 = require('./PaginationButton');

var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Pagination = _Pagination3.default;
exports.PaginationButton = _PaginationButton3.default;